/**
 * Created by pyt on 2017-03-07.
 */
import { FilterComparisonOperator } from '@/common/models';
import FilterBase from '@/common/models/query-params/FilterBase';

import Filter from './Filter';
import * as ComparisonOperator from './FilterComparisonOperator';
import LogicalOperator from './FilterLogicalOperator.enum';

export default class BooleanFilter extends FilterBase {
  type: string;
  property: string;
  value: boolean;
  comparisonOperator: FilterComparisonOperator;
  logicalOperator: LogicalOperator;
  label: string;
  checkForEmptyness: boolean;

  constructor(property = null, label = null, value = null, checkForEmptyness = false) {
    super();
    this.type = 'BooleanFilter';
    this.property = property;
    this.value = value;
    this.comparisonOperator = ComparisonOperator.EQUAL;
    this.logicalOperator = LogicalOperator.OR;
    this.label = label;
    this.checkForEmptyness = checkForEmptyness;
  }

  get isEmpty() {
    return this.value == null;
  }

  getFilters() {
    return this.checkForEmptyness
      ? [
          new Filter(
            this.property,
            this.checkForEmptyness?.customComparisonValue || [null, 0],
            this.value ? FilterComparisonOperator.NOT_EQUAL : FilterComparisonOperator.EQUAL,
          ),
        ]
      : [new Filter(this.property, [this.value], FilterComparisonOperator.EQUAL)];
  }

  clear() {
    this.value = true;
  }

  serializeForQueryString() {
    return `${this.property}~${this.value}`;
  }

  static deserializeFromQueryString(filter, serialized) {
    const fragments = serialized.split('~');
    const instance = new BooleanFilter(filter.property, filter.label, fragments[1] === 'true');
    return instance;
  }

  toApi() {
    return {
      property: this.property,
      label: this.label,
      value: this.value,
      checkForEmptyness: this.checkForEmptyness,
    };
  }

  static fromApi(apiObject) {
    const filter = new BooleanFilter(apiObject.property, apiObject.label, apiObject.value, apiObject.checkForEmptyness);
    filter.instance = apiObject.instance;
    return filter;
  }
}
